export default __webpack_public_path__ + "assets/images/4f95679e5430041071fa1c47f77176fb.jpg";